import React from 'react';
import { Grid, makeStyles, Typography, createStyles, Theme as AugmentedTheme } from '@material-ui/core';
import { FroalaDescription } from '../FroalaDescription';

interface IProps {
    title: string,
    finishMessage?: string
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    blockHolder: {
        height: '100vh',
    },
    //@ts-ignore
    formControl: theme.formControl,
    //@ts-ignore
    formControlBorder: theme.formControlBorder,
    formTitle: theme.formTitle,
    formDescription: theme.formDescription,
}))

export default function Congrats({title,finishMessage}: IProps) {
    const classes = useStyles();

    return(
        <Grid container direction="column" alignItems="center" className={classes.blockHolder}>
            <Grid container direction="column" className={`${classes.formControl} ${classes.formControlBorder}`}>
                <Typography dir='auto' variant="h1" className={classes.formTitle}>{title}</Typography>
                { finishMessage ? <FroalaDescription  mailHtmlContent={finishMessage} /> :
                <Typography dir='auto' className={classes.formDescription}>Your form has been submitted successfully. Thank You!</Typography>}
            </Grid>
        </Grid>
    )
}
